import { CARD_TYPES } from './card-input-constants'

export const getCardTypeByValue = (value) => {
  return CARD_TYPES.filter((cardType) => cardType.startPattern.test(value))[0]
}

export const formatCardNumber = (cardNumber = '') => {
  const cardType = getCardTypeByValue(cardNumber)

  if (cardType === undefined) {
    return (cardNumber.match(/\d+/g) ?? []).join('')
  }

  const { format } = cardType

  if (format.global) {
    return cardNumber.match(format)?.join(' ') ?? ''
  }

  const execResult = format.exec(cardNumber.split(' ').join(''))

  if (execResult != null) {
    return execResult
      .splice(1, 3)
      .filter((x) => x)
      .join(' ')
  }
  return cardNumber
}
